const WORKSPACE_CUSTOMER_ID_KEY = "sagelyn_workspace_customer_id";
const WORKSPACE_CUSTOMER_NAME_KEY = "sagelyn_workspace_customer_name";

/** Legacy keys (pre–Sagelyn branding); read once and migrate. */
const LEGACY_WORKSPACE_CUSTOMER_ID_KEY = "daisy_workspace_customer_id";
const LEGACY_WORKSPACE_CUSTOMER_NAME_KEY = "daisy_workspace_customer_name";

export type PersistedWorkspace = {
  id: string | null;
  name: string | null;
};

function migrateLegacyStringKey(
  nextKey: string,
  legacyKey: string
): string | null {
  try {
    const next = localStorage.getItem(nextKey)?.trim();
    if (next) return next;
    const legacy = localStorage.getItem(legacyKey)?.trim();
    if (!legacy) return null;
    localStorage.setItem(nextKey, legacy);
    localStorage.removeItem(legacyKey);
    return legacy;
  } catch {
    return null;
  }
}

export function readPersistedWorkspace(): PersistedWorkspace {
  if (typeof window === "undefined") return { id: null, name: null };
  try {
    const id =
      migrateLegacyStringKey(WORKSPACE_CUSTOMER_ID_KEY, LEGACY_WORKSPACE_CUSTOMER_ID_KEY) ??
      null;
    const name =
      migrateLegacyStringKey(
        WORKSPACE_CUSTOMER_NAME_KEY,
        LEGACY_WORKSPACE_CUSTOMER_NAME_KEY
      ) ?? null;
    return { id, name };
  } catch {
    return { id: null, name: null };
  }
}

/** Persist workspace selection so reload keeps the same business profile. */
export function writePersistedWorkspace(
  id: string | null,
  name: string | null
): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.removeItem(LEGACY_WORKSPACE_CUSTOMER_ID_KEY);
    localStorage.removeItem(LEGACY_WORKSPACE_CUSTOMER_NAME_KEY);
    if (id) {
      localStorage.setItem(WORKSPACE_CUSTOMER_ID_KEY, id);
      if (name && name.trim()) {
        localStorage.setItem(WORKSPACE_CUSTOMER_NAME_KEY, name.trim());
      } else {
        localStorage.removeItem(WORKSPACE_CUSTOMER_NAME_KEY);
      }
    } else {
      localStorage.removeItem(WORKSPACE_CUSTOMER_ID_KEY);
      localStorage.removeItem(WORKSPACE_CUSTOMER_NAME_KEY);
    }
  } catch {
    /* ignore quota / private mode */
  }
}

/** Call on logout so the next user never inherits another account's workspace. */
export function clearPersistedWorkspace(): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.removeItem(WORKSPACE_CUSTOMER_ID_KEY);
    localStorage.removeItem(WORKSPACE_CUSTOMER_NAME_KEY);
    localStorage.removeItem("sagelyn_workspace_recent_customer_ids");
    localStorage.removeItem("daisy_workspace_recent_customer_ids");
    localStorage.removeItem(LEGACY_WORKSPACE_CUSTOMER_ID_KEY);
    localStorage.removeItem(LEGACY_WORKSPACE_CUSTOMER_NAME_KEY);
  } catch {
    /* ignore */
  }
}
